import { ethers } from 'ethers';
import { Employee } from '../interfaces/Employee';
import { AMOUNT_PATTERN } from './amounts';

export interface NewEmployee {
  full_name: string;
  wallet_address: string;
  salary: string;
}

/**
 * Проверка формы добавления. Возвращает текст ошибки или пустую строку.
 * Правила совпадают с бэком: то, что пройдёт здесь, бэк не отвергнет.
 */
export const validateNewEmployee = (
  employee: NewEmployee,
  employees: Employee[],
): string => {
  const fullName = employee.full_name.trim();
  const wallet = employee.wallet_address.trim();

  if (!fullName) return 'Введите ФИО сотрудника';
  if (fullName.length > 255) return 'ФИО слишком длинное';

  if (employees.some((e) => e.full_name === fullName)) {
    return 'Такой сотрудник уже работает';
  }

  if (!wallet) return 'Введите адрес кошелька сотрудника';
  if (!ethers.isAddress(wallet)) return 'Адрес кошелька указан неверно';

  if (
    employees.some(
      (e) => e.wallet_address.toLowerCase() === wallet.toLowerCase(),
    )
  ) {
    return 'Сотрудник с этим кошельком уже есть';
  }

  return validateAmount(employee.salary, 'Оклад', { positive: true });
};

/** Сумма из поля ввода: до двух знаков после запятой, меньше миллиона. */
export const validateAmount = (
  value: string,
  label: string,
  { positive = false } = {},
): string => {
  const text = value.trim();

  if (!text) return `Введите: ${label.toLowerCase()}`;
  if (!AMOUNT_PATTERN.test(text)) {
    return `${label}: число меньше миллиона, не больше двух знаков после запятой`;
  }
  if (positive && Number(text) <= 0) return `${label} должен быть больше нуля`;

  return '';
};
